import $ from "jquery";
import "jqtree/tree.jquery";
import MenuItem from './MenuItem.vue';
import { createApp } from 'vue';

$('[data-component="menu"]').each(function() {
    const csrfToken = $(this).data('csrfToken');
    $(this).tree({
        data: $(this).data('tree'),
        dragAndDrop: true,
        autoOpen: true,
        closedIcon: $('<i class="material-icons">chevron_right</i>'),
        openedIcon: $('<i class="material-icons">expand_more</i>'),
        onCanMove: node => node.parent !== null,
        onCanMoveTo: (moved_node, target_node, position) => !(target_node.level === 0 && (position === 'after' || position === 'before')),
        onIsMoveHandle: function($element) {
            return ($element.is('.jqtree-title .drag-handler'));
        },
        onCreateLi: (node, $li) => {
            const $title = $li.find('.jqtree-title');
            createApp(MenuItem, { node, csrfToken }).mount($title[0]);
        }
    }).on('tree.move', async e => {
        e.preventDefault();
        const formData = new FormData;
        formData.append('node', e.move_info.moved_node.id);
        formData.append('position', e.move_info.position);
        formData.append('previousParent', e.move_info.previous_parent.id);
        formData.append('target', e.move_info.target_node.id);
        formData.append('_token', csrfToken);
        const response = await fetch($(this).data('updateUrl'), {
            'method': 'POST',
            'body': formData
        });

        if (await response && response.redirected) {
            window.location.href = response.url;
        }

        const responseData = await response.json();

        if (responseData.status === 'OK') {
            e.move_info.do_move();
        }
    })
});
